import type { IEntity } from "dxf-parser";
import type { IGroup } from "dxf-parser/dist/DxfArrayScanner";
import type DxfArrayScanner from "dxf-parser/dist/DxfArrayScanner";
import type IGeometry from "dxf-parser/dist/entities/geomtry";
import * as helpers from "lib/house/dxf/import/dxfParserLibHelpers";

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface IAttribEntity extends IEntity {
  tag?: string;
  text?: string;
  textHeight?: number;
  textRotation?: number;
  insertionPoint?: { x: number; y: number; z: number };
  anchorPoint?: { x: number; y: number; z: number };
  halign: number;
  valign: number;
}

export default class Attrib implements IGeometry {
  public ForEntityName = "ATTRIB" as any;

  public parseEntity(scanner: DxfArrayScanner, curr: IGroup) {
    const entity = {
      type: curr.value,
    } as IAttribEntity;

    curr = scanner.next();

    while (!scanner.isEOF()) {
      if (curr.code === 0) {
        break;
      }

      switch (curr.code) {
        case 10:
        case 20:
        case 30:
          entity.insertionPoint = helpers.parsePoint(scanner);
          break;
        case 11:
        case 21:
        case 31:
          entity.anchorPoint = helpers.parsePoint(scanner);
          break;
        case 40:
          entity.textHeight = parseInt(curr.value as string, 10);
          break;
        case 50:
          entity.textRotation = parseInt(curr.value as string, 10);
          break;
        case 1:
          entity.text = curr.value as string;
          break;
        case 2:
          entity.tag = curr.value as string;
          break;
        case 72: // Horizontal alignment
          entity.halign = curr.value as number;
          break;
        case 74: // Vertical alignment
          entity.valign = curr.value as number;
          break;
        default:
          helpers.checkCommonEntityProperties(entity, curr, scanner);
          break;
      }

      curr = scanner.next();
    }

    return entity;
  }
}
